<template>
    <div id="submitAudit">
        <!-- 导航栏 -->
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">提交审核</div>
            <div class="rule" @click="inHighTaskExamineByLaws">细则</div>
        </div>
        <!-- 任务注册账号 手机号码  -->
        <div class="editText">
            <input type="text" maxlength="11" v-if="detailDatas.check_tuser == 1" v-model="phones" placeholder="请输入手机号" class="regNum">
            <input type="text" v-for="(ite,ind) in detailDatas.description" :key="ind" v-model="inputList[ind].name" :placeholder="'请输入'+ite.key" class="regNum">
        </div>
        <!-- 上传截图 -->
        <div class="uploadPictures">
            <div class="title">
                <span class="redLine"></span>
                <span class="txt">上传截图</span>
                <span class="redLine"></span>
            </div>

            <div class="pictureFathers" v-for="(item,nums) in detailDatas.step" :key="nums">
                <div class="picture" v-for="(ites,inds) in item.url" :key="inds" v-if="ites.screenshot">
                    <div class="example">
                        <img :src="ites.url" v-preview="ites.url" alt="">
                        <span>示例图</span>
                    </div>
                    <div class="choiceImg">
                        <img :src="uploadPic[ites.index].imgUrl" alt="">
                        <img src="../assets/images/img_14.png" alt="" v-if="uploadPic[ites.index].show">
                        <input type="file"  accept="image/jpeg,image/png,image/jpg,image/gif" @change='getimg($event,ites.index)'>
                    </div>
                </div>
            </div>

            <div class="btn" @click="submitAudit">提交审核</div>
            <div class="explain">请参照示例图上传</div>
        </div>


        <ExamineSlowPop :slows="slows" :icons="icons"></ExamineSlowPop>
    </div>
</template>

<script>
    import ExamineSlowPop from '../components/examineSlowPop.vue'
    export default {
        components:{
            ExamineSlowPop
        },
        data() {
            return {
                regNum:'',
                imgss:require('../assets/images/img_70.png'),

                uploadImage: "",

                detailDatas:[], // 请求数据
                phones:'', // 手机号
                inputList:[], // 绑定数据
                uploadPic:[], // 图片浏览
                files:[], // 图片

                slows: false, // 弹窗控制
                icons: '', // 弹窗图像
            }
        },
        mounted() {
            this.icons = this.$route.query.icons
            this.init();
        },
        methods: {
            // 初始化请求(详情页数据)
            init(){
                this.$loading(true);
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('volume_task/detail',datas,(res)=>{
                    console.log(res.data)
                    for(let i=0;i<res.data.description.length;i++){
                        var vote = {};
                        vote.key = res.data.description[i].key;
                        vote.name = '';
                        this.inputList.push(vote);
                    }
                    for(let j=0;j<res.data.step.length;j++){
                        for(let k=0;k<res.data.step[j].url.length;k++){
                            let urlObj = {};
                            urlObj.imgUrl = '';
                            urlObj.show = true;
                            this.uploadPic.push(urlObj);
                            if(res.data.step[j].url[k].screenshot == 1) {
                                this.files.push('');
                            }
                        }
                    }
                    console.log(this.files);
                    console.log(this.uploadPic);
                    this.detailDatas = res.data
                    this.$loading(false);
                });
            },
            // 返回
            returnPage:function(){
                this.$router.go(-1);
            },
            // 进入 提交审核细则
            inHighTaskExamineByLaws:function(){
                this.$router.push('/highTask/highTaskExamineByLaws');
            },

            // 封装一个base64转file的函数
            base64ToFile(dataurl, filename) {
                //将base64转换为文件
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            // 封装一个Blob转base64的函数
            blobToBase64(blobObj) {
                return new Promise((resolve, reject) => {
                    let fr = new FileReader();
                    if(blobObj instanceof Blob) {
                        fr.readAsDataURL(blobObj);
                        fr.onload = function() {
                            resolve(this.result);
                        }
                    }
                });  
            },
            // 封装一个图片压缩函数
            compressImg(img_path, params_quality) {
                console.log("get in and start compress");
                var img = new Image();
                img.src = img_path;
                return new Promise((resolve, reject) => {
                    img.onload = function(){
                        var w = this.width,
                            h = this.height,
                            scale = w / h;
                        w = params_quality.w || w;
                        h = params_quality.h || h;

                        //创建canvas
                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');
                        canvas.width = w;
                        canvas.height = h;
                        ctx.drawImage(this, 0, 0, w, h);

                        var quality = 0.7;
                        if(params_quality.quality && params_quality.quality > 0 && params_quality.quality <= 1){
                            quality = params_quality.quality;
                        }
                        var base64_temp = canvas.toDataURL('image/jpeg', quality);
                        //返回压缩后的图片的base64
                        resolve(base64_temp);
                    }
                });
            },
            // 上传图片
            getimg(e,indexs) {
                let that = this;
                var files = e.target.files[0];
                // 如果图片大小大于2M则开启压缩
                if(files.size > 1024 * 1024 * 1) {
                    this.blobToBase64(files).then((res) => {
                        this.compressImg(res, { quality: 0.6 }).then((res) => {
                            let file = this.base64ToFile(res, files.name);
                            this.files[indexs] = file;
                        });
                    });
                }else {
                    this.files[indexs] = files;
                }

                console.log(this.files)

                if (!e || !window.FileReader) return; // 看支持不支持FileReader

                if(files){
                    let reader = new FileReader();
                    reader.readAsDataURL(files);  // 读取文件
                    reader.onloadend = function() {
                        that.uploadPic[indexs].show=false;
                        that.uploadPic[indexs].imgUrl = this.result;
                    };
                }
            },

            // 提交审核
            submitAudit(){
                console.log(this.files);
                let formData = new FormData();

                formData.append("task_id", this.$route.query.ids);

                if(this.detailDatas.check_tuser == 1){
                    if(!(/^1[3456789]\d{9}$/.test(this.phones))){ 
                        this.$loading(false);
                        this.$toast('请输入正确的手机号')
                        return;
                    }
                    formData.append("phone", this.phones);
                }
                let description = {
                    key:[],
                    value:[]
                }
                for(var i=0;i<this.inputList.length;i++){
                    description.key.push(this.inputList[i].key)
                    description.value.push(this.inputList[i].name)
                }

                formData.append("description",JSON.stringify(description));

                for(var j=0;j<this.files.length;j++){
                    formData.append("img"+j,this.files[j]);
                }
                this.$loading(true);
                this.$http.POSTS('volume_task/submit',formData,(res)=>{
                    this.$loading(false);
                    if(!this.slows){
                        this.slows = true;
                        setTimeout(()=>{
                            this.slows = false;
                            this.$router.go(-2);
                        },2000)
                    }
                });

                
            }
        },

        beforeRouteEnter(to, from, next) {
            if(from.name=='highTaskExamineByLaws'){
                to.meta.keepAlive = true;
            } else {
                to.meta.keepAlive = false;
            }
            next();
        },
    }
</script>

<style lang="less" scoped>
    #submitAudit{
        width: 100%;
        height: 100%;
        overflow: scroll;
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            .rule{
                font-size:15px;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 25px;
            }
        }
        // 任务注册账号 手机号码
        .editText{
            margin: 31px 20px 25px;
            box-shadow:0px 0px 10px 0px rgba(0,0,0,0.05);
            .regNum{
                width: 293px;
                height: 48px;
                border: none;
                font-size: 15px;
                text-align: center;
                padding: 0 20px;
                box-shadow:0px 5px 10px rgba(0,0,0,.05);
                margin-bottom: 1px;
                &:first-of-type{
                    border-radius: 5px 5px 0 0;
                }
                &:last-of-type{
                    border-radius: 0 0 5px 5px;
                }
                &:not(:last-of-type){
                    border-bottom: none;
                }
                &:focus{
                    outline:none;
                }
            }
            #phoneNum{
                width: 293px;
                height: 48px;
                border: none;
                font-size: 15px;
                border-radius: 0 0 5px 5px;
                text-align: center;
                padding: 0 20px;
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border:1px solid rgba(222,222,222,1);
                border-top: none;
                margin-bottom: 25px;
                &:focus{
                    outline:none;
                }
            }
        }
        // 上传截图
        .uploadPictures{
            margin: 0 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 6px;
                .redLine{
                    display: inline-block;
                    width:10px;
                    height:3px;
                    background:rgba(229,1,19,1);
                    border-radius:2px;
                    margin: 0 5px;
                }
                .txt{
                    font-size:15px;
                    font-weight:600;
                    color:rgba(21,21,21,1);
                    line-height:15px;
                }
            }
            .pictureFathers{
                width: 100%;
                .picture{
                    width: 100%;
                    display: flex;
                    justify-content: space-around;
                    padding-top: 10px;
                    .example{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        img{
                            width: 90px;
                            height: 160px;
                        }
                        span{
                            font-size:15px;
                            font-weight:600;
                            color:rgba(21,21,21,1);
                            line-height:15px;
                            margin-top: 11px;
                        }
                    }
                    .choiceImg{
                        width: 90px;
                        height: 160px;
                        position: relative;
                        img{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            display: block;
                            top:0;
                        }
                        input {
                            display: block;
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                            z-index: 10000;
                        }
                    }
                    
                }
            }
            
            .btn{
                width:250px;
                height:45px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                border-radius:25px;
                font-size:15px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:45px;
                text-align: center;
                margin: 30px 0 30px;
            }
            .explain{
                font-size:13px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:20px;
                padding-bottom: 15px;
            }
        }
        
    }
</style>